import type { EthereumAddress } from "@bracket/types";

export const address: EthereumAddress = "0x6C8550167BbD06D4610a6A443eCbEd84Bd1AccD6";

export const abi = [
	{
		type: "function",
		name: "addCollateral",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "allowance",
		inputs: [
			{
				name: "owner",
				type: "address",
				internalType: "address",
			},
			{
				name: "spender",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "approve",
		inputs: [
			{
				name: "spender",
				type: "address",
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "balanceOf",
		inputs: [
			{
				name: "account",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "blacklistCollateral",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "burn",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "minColAmount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "calculateBurn",
		inputs: [
			{
				name: "brktAmount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "calculateMint",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "calculateMint",
		inputs: [
			{
				name: "value",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "brktAmount",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "claimWithdrawal",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "timestamp",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "getBracketRate",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getBracketValue",
		inputs: [
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getCollateralInfo",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [
			{
				name: "",
				type: "tuple",
				internalType: "struct IBrktETH.CollateralInfo",
				components: [
					{
						name: "collateral",
						type: "address",
						internalType: "address",
					},
					{
						name: "whitelisted",
						type: "bool",
						internalType: "bool",
					},
					{
						name: "totalDeposit",
						type: "uint256",
						internalType: "uint256",
					},
				],
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "getTotalValue",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "getWithdrawalStatusAndHash",
		inputs: [
			{
				name: "user",
				type: "address",
				internalType: "address",
			},
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "timestamp",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		outputs: [
			{
				name: "",
				type: "uint8",
				internalType: "enum IBrktETH.WithdrawalStatus",
			},
			{
				name: "",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "hashWithdrawal",
		inputs: [
			{
				name: "user",
				type: "address",
				internalType: "address",
			},
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "time",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		outputs: [
			{
				name: "",
				type: "bytes32",
				internalType: "bytes32",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "mint",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
			{
				name: "amount",
				type: "uint256",
				internalType: "uint256",
			},
			{
				name: "minBrktAmount",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "brktAmount",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "setOracle",
		inputs: [
			{
				name: "_oracle",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "totalSupply",
		inputs: [],
		outputs: [
			{
				name: "",
				type: "uint256",
				internalType: "uint256",
			},
		],
		stateMutability: "view",
	},
	{
		type: "function",
		name: "transfer",
		inputs: [
			{
				name: "to",
				type: "address",
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "transferFrom",
		inputs: [
			{
				name: "from",
				type: "address",
				internalType: "address",
			},
			{
				name: "to",
				type: "address",
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				internalType: "uint256",
			},
		],
		outputs: [
			{
				name: "",
				type: "bool",
				internalType: "bool",
			},
		],
		stateMutability: "nonpayable",
	},
	{
		type: "function",
		name: "whitelistCollateral",
		inputs: [
			{
				name: "token",
				type: "address",
				internalType: "address",
			},
		],
		outputs: [],
		stateMutability: "nonpayable",
	},
	{
		type: "event",
		name: "Approval",
		inputs: [
			{
				name: "owner",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "spender",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "Mint",
		inputs: [
			{
				name: "user",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "token",
				type: "address",
				indexed: false,
				internalType: "address",
			},
			{
				name: "colAmount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "brktAmount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "Mint",
		inputs: [
			{
				name: "user",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "tokens",
				type: "address[]",
				indexed: false,
				internalType: "address[]",
			},
			{
				name: "colAmounts",
				type: "uint256[]",
				indexed: false,
				internalType: "uint256[]",
			},
			{
				name: "brktAmount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "Transfer",
		inputs: [
			{
				name: "from",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "to",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "value",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "WithdrawalClaimed",
		inputs: [
			{
				name: "user",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "token",
				type: "address",
				indexed: false,
				internalType: "address",
			},
			{
				name: "colAmount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "scheduledTimestamp",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
		],
		anonymous: false,
	},
	{
		type: "event",
		name: "WithdrawalScheduled",
		inputs: [
			{
				name: "user",
				type: "address",
				indexed: true,
				internalType: "address",
			},
			{
				name: "token",
				type: "address",
				indexed: false,
				internalType: "address",
			},
			{
				name: "colAmount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "brktAmount",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "timestamp",
				type: "uint256",
				indexed: false,
				internalType: "uint256",
			},
			{
				name: "salt",
				type: "bytes32",
				indexed: false,
				internalType: "bytes32",
			},
		],
		anonymous: false,
	},
	{
		type: "error",
		name: "CollateralAlreadyExists",
		inputs: [],
	},
	{
		type: "error",
		name: "CollateralNotBlacklisted",
		inputs: [],
	},
	{
		type: "error",
		name: "CollateralNotEmpty",
		inputs: [],
	},
	{
		type: "error",
		name: "CollateralNotExists",
		inputs: [],
	},
	{
		type: "error",
		name: "CollateralNotSupported",
		inputs: [],
	},
	{
		type: "error",
		name: "CollateralNotWhitelisted",
		inputs: [],
	},
	{
		type: "error",
		name: "DiffArraySize",
		inputs: [],
	},
	{
		type: "error",
		name: "MaxAmountInExceeded",
		inputs: [],
	},
	{
		type: "error",
		name: "MaxCollateralsReached",
		inputs: [],
	},
	{
		type: "error",
		name: "MinAmountOutNotMet",
		inputs: [],
	},
	{
		type: "error",
		name: "NotEnoughCollateral",
		inputs: [],
	},
	{
		type: "error",
		name: "SameCollateral",
		inputs: [],
	},
	{
		type: "error",
		name: "WithdrawalAlreadyQueued",
		inputs: [],
	},
	{
		type: "error",
		name: "WithdrawalNotReady",
		inputs: [],
	},
	{
		type: "error",
		name: "ZeroAddress",
		inputs: [],
	},
	{
		type: "error",
		name: "ZeroAmount",
		inputs: [],
	},
] as const;
